module.exports = __webpack_public_path__ + "img/instrumentacion_y_procesos.0697fe22.jpg";